webpackJsonp([156897593687669],{

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(19);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(302);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResumePage = function ResumePage() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'resumePage' },
	        _react2.default.createElement(
	            'div',
	            { className: 'resume' },
	            _react2.default.createElement(
	                'div',
	                { className: 'resume__contact' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'resume__contact--name' },
	                    _react2.default.createElement(
	                        'h1',
	                        { className: 'resume__heading' },
	                        'Nedu Robert'
	                    ),
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        'Full Stack Developer'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'resume__contact--info' },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'info' },
	                            'Github:'
	                        ),
	                        ' ',
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'https://github.com/nedu' },
	                            'https://github.com/nedu'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'info' },
	                            'Email:'
	                        ),
	                        ' ',
	                        _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: '/contact' },
	                            'nedumrobert@gmail.com'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'info' },
	                            'Portfolio:'
	                        ),
	                        ' ',
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'https://nedu.github.io/' },
	                            'nedu.github.io'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'info' },
	                            'LinkedIn:'
	                        ),
	                        ' ',
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'https://www.linkedin.com/in/nedurobert/' },
	                            'https://www.linkedin.com/in/nedurobert/'
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'resume__profile' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'resume__profile--name' },
	                    _react2.default.createElement(
	                        'h1',
	                        { className: 'resume__heading' },
	                        'Profile'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'resume__profile--info' },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'Highly motivated and demonstrated Full-Stack Developer.'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'Fluent in designing and working with RESTful APIs. '
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'Effective at managing projects both independently and as a team player.'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'Quick at adapting to new technologies and learning new skills.'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'resume__projects' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'resume__projects--name' },
	                    _react2.default.createElement(
	                        'h1',
	                        { className: 'resume__heading' },
	                        'Projects'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'resume__projects--info' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'project' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'project-info' },
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'info' },
	                                    'Closet Roulette '
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'https://www.closetroulette.com/' },
	                                    'https://www.closetroulette.com/'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Full Stack Developer on a team of five that built a digital closet that enables users to upload images of their outfits and transforms them into virtual attire.'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Utilized the MERN stack to build out the web application and used the Stripe API for onlinepayment processing.'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Implemented authentication and authorization using token based authentication and OAuth 2.0.'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Integrated the SendGrid API for delivering of emails to users.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'project' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'project-info' },
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'info' },
	                                    'Lambda Notes'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'https://lambda-notes-app.netlify.com/' },
	                                    'https://lambda-notes-app.netlify.com/'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Built a Full Stack note taking web application using MERN that allows authenticated users to manage their notes.'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Incorporated REST architecture and authentication using Express.js, Node.js, Passport and MongoDB to manipulate notes data.'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Implemented markdown, searching, sorting and exporting functionality.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'project' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'project-info' },
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'info' },
	                                    'Random Quote Generator'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'https://nedu.github.io/RQG/' },
	                                    'https://nedu.github.io/RQG/'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Designed and developed a Random Quote Generator web application which displays to the user random quotes on the click of a button using JavaScript ES6+.'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Incorporated AJAX while utilizing a JSON-encoded, third party external API to fetch the quotes data.'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Integrated Twitter Web Intents to enable user to tweet out the quotes.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'project' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'project-info' },
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'info' },
	                                    'WikiSearch'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'https://nedu.github.io/WikiSearch/' },
	                                    'https://nedu.github.io/WikiSearch/'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Engineered a single-page web application in react to enable users search for articles on wikipedia.'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Utilizes the MediaWiki API to search for the user\'s query.'
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'resume__techskills' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'resume__techskills--name' },
	                    _react2.default.createElement(
	                        'h1',
	                        { className: 'resume__heading' },
	                        'Skills'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'resume__techskills--info' },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'info' },
	                            'Programming Languages: '
	                        ),
	                        'JavaScript, Python'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'info' },
	                            'Frameworks & Libraries:'
	                        ),
	                        ' React, Redux, Node, Express, Mongoose, Django'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'info' },
	                            'Web Technologies:'
	                        ),
	                        ' HTML5, CSS3, AJAX, JSON'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'info' },
	                            'Databases:'
	                        ),
	                        ' MongoDB, MySQL, SQLite, PostgreSQL'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'info' },
	                            'Tools:'
	                        ),
	                        ' Git, Heroku'
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = ResumePage;
	module.exports = exports['default'];

/***/ }),

/***/ 302:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-resume-js-78718bd0666b06feac7e.js